import * as React from 'react';

export const styles: { [key: string]: React.CSSProperties } = {
    loading: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 300
    },
    message: {
        padding: 20,
        textAlign: 'center'
    },
};
